import {
  Box,
  Button,
  Chip,
  CircularProgress,
  FormControl,
  List,
  ListItem,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import GenericLoadError from '../common/GenericLoadError'
import PageTitle from '../common/PageTitle'
import useCustomers from '../hooks/api/useCustomers'
import useGenericEndpoint from '../hooks/api/useGenericEndpoint'

// import TaskModal from './task/TaskModal'

const CustomerList = () => {
  // const [isModalOpen, setIsModalOpen] = useState(false)
  // const [currentCustomer, setCurrentCustomer] = useState(null)

  const [sort, setSort] = useState('ASC')

  const [activeStatusFilter, setActiveStatusFilter] = useState(null)

  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const { customers, hasLoadError, isLoading, recent } = useCustomers(null, {
    include_recent: true,
    status_id: activeStatusFilter,
    sort,
  })

  const { data: customerStatusTypesData, ..._customerStatusTypes } =
    useGenericEndpoint('/api/customer/types/status')

  useEffect(() => {
    if (searchParams.get('preventRedirect') === 'true') return

    if (recent[0]) {
      navigate(`/customers/${recent[0].id}`)
    }
  }, [recent, searchParams])

  const createCustomer = () => {
    navigate('/customers/new')
  }

  const navigateToCustomer = (id) => {
    navigate(`/customers/${id}`)
  }

  // if (isLoading || _customerStatusTypes.isLoading) return <CircularProgress />
  // if (hasLoadError || _customerStatusTypes.hasLoadError)
  //   return <GenericLoadError />

  const chips = customerStatusTypesData
    ? [{ id: null, name: 'All Accounts' }]
        .concat(customerStatusTypesData.customerStatusTypes)
        .concat([{ id: '__PARTNER__', name: 'Partner' }])
        .concat([{ id: '__OPEN_TICKETS__', name: 'Open Tickets' }])
    : []

  return (
    <Box className='customer-list-container'>
      <Box className='add-customer-button-container'>
        <Button color='primary' variant='contained' onClick={createCustomer}>
          Add a new account
        </Button>
      </Box>
      <PageTitle>Accounts View</PageTitle>
      {!_customerStatusTypes.isLoading && !_customerStatusTypes.hasLoadError && (
        <Box sx={{ ml: 1, my: 1, mt: 2 }}>
          {chips.map((st) => {
            return (
              <Chip
                color={activeStatusFilter === st.id ? 'primary' : 'default'}
                sx={{ m: 0.5 }}
                label={st.name}
                key={st.id}
                onClick={() =>
                  setActiveStatusFilter(
                    st.id === activeStatusFilter ? null : st.id
                  )
                }
              />
            )
          })}
        </Box>
      )}
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography sx={{ mx: 2 }}>Total: {customers.length}</Typography>
        <FormControl margin='dense'>
          <ToggleButtonGroup
            value={sort}
            exclusive
            onChange={(e) => setSort(e.target.value)}
            color='primary'
          >
            <ToggleButton value={'ASC'}>Ascending</ToggleButton>
            <ToggleButton value={'DESC'}>Descending</ToggleButton>
          </ToggleButtonGroup>
        </FormControl>
      </Box>
      {customers.length === 0 ? (
        <Box sx={{ ml: 2, mt: 2 }}>No Accounts Found</Box>
      ) : (
        <>
          {!isLoading && !hasLoadError && (
            <List>
              {customers.map((c) => {
                return (
                  <ListItem key={c.id} className='list-item'>
                    <div>
                      <Button onClick={() => navigateToCustomer(c.id)}>
                        {c.name}
                        {!activeStatusFilter &&
                          ` - ${c.typeId === 3 ? 'Partner' : c.status}`}
                      </Button>
                    </div>
                  </ListItem>
                )
              })}
            </List>
          )}
          {isLoading && <CircularProgress />}
          {hasLoadError && <GenericLoadError />}
        </>
      )}
      {/* <TaskModal
        customer={currentCustomer}
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
      ></TaskModal> */}
    </Box>
  )
}

export default CustomerList
